import React from 'react';
import Styles from './index.module.scss';
import DocTree from '@/assets/skeleton.svg';

function RenderList() {
  return (
    <div className={Styles.list}>
      <div className={Styles.header} />
      {[1, 2, 3, 4].map((item) => (
        <div className={Styles.item} key={item}>
          <div className={Styles.itemleft} />
          <div className={Styles.itemright} />
        </div>
      ))}
    </div>
  );
}

function RenderBlock() {
  return (
    <>
      <div className={Styles.blockheader} />
      <div className={Styles.block}>
        {[1, 2, 3, 4, 5].map((item) => (
          <div className={Styles.blockitem} key={item} />
        ))}
      </div>
    </>
  );
}

function Skeleton() {
  return (
    <div className={Styles.skeleton}>
      {/* {RenderList()} */}
      {RenderList()}
      {RenderBlock()}
    </div>
  );
}

export function ListSkeleton() {
  return (
    <div style={{ flex: 1 }}>
      <img src={DocTree} alt="skeleton" style={{ width: '100%', marginTop: '10px' }} />
    </div>
  );
}

export function TextSkeleton() {
  return <div className={Styles.text} />;
}

export function DocTreeSleleton() {
  return (
    <div className={Styles.docTree}>
      <img src={DocTree} alt="skeleton" style={{ width: '100%' }} />
    </div>
  );
}

export default Skeleton;

export function ServiceList() {
  return (<div className={Styles.serviceListContainer}>{[1, 2, 3, 4].map((item: number) => <div key={item} className={Styles.serviceList} />)}</div>);
}
